module.exports = __webpack_public_path__ + "img/llamadas.b8012f07.png";